var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isShow
    ? _c("div", { staticClass: "popup" }, [
        _c(
          "div",
          { staticClass: "content", attrs: { id: "emailPasteOption" } },
          [
            _c("div", { staticClass: "title" }, [
              _vm.isCut
                ? _c("span", [
                    _vm._v(_vm._s(_vm.$t("language.emailTransfer.cutSetting")))
                  ])
                : _c("span", [
                    _vm._v(_vm._s(_vm.$t("language.emailTransfer.copySetting")))
                  ]),
              _vm._v(" "),
              _c("div", {
                staticClass: "icon white-close dialog-close",
                on: {
                  click: function($event) {
                    return _vm.close()
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "popup-content" }, [
              _c("div", { staticClass: "email-paste-options" }, [
                _vm.isExists
                  ? _c("div", { staticClass: "email-paste-option-title" }, [
                      _vm._v(
                        _vm._s(_vm.$t("language.emailTransfer.settingTips"))
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "email-paste-option" }, [
                  _c("div", {
                    staticClass: "icon-util",
                    class: _vm.options.isSaveAtt
                      ? "check-small"
                      : "nocheck-small-blue",
                    on: {
                      click: function($event) {
                        _vm.options.isSaveAtt = !_vm.options.isSaveAtt
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(_vm._s(_vm.$t("language.emailTransfer.saveAtt")))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "email-paste-option" }, [
                  _c("div", {
                    staticClass: "icon-util",
                    class: _vm.options.isConver
                      ? "check-small"
                      : "nocheck-small-blue",
                    on: {
                      click: function($event) {
                        _vm.options.isConver = !_vm.options.isConver
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(
                      _vm._s(_vm.$t("language.emailTransfer.converFormat"))
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "icon-util question-mark" }, [
                    _c("div", { staticClass: "plan-questionTxt" }, [
                      _vm._v(
                        _vm._s(_vm.$t("language.emailTransfer.converFormatTip"))
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "email-paste-option" }, [
                  _c("div", {
                    staticClass: "icon-util",
                    class: _vm.options.isSaveOnly
                      ? "check-small"
                      : "nocheck-small-blue",
                    on: {
                      click: function($event) {
                        _vm.options.isSaveOnly = !_vm.options.isSaveOnly
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(_vm._s(_vm.$t("language.emailTransfer.saveOnly")))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "email-paste-option" }, [
                  _c("div", {
                    staticClass: "icon-util",
                    class: _vm.options.delWatermark
                      ? "check-small"
                      : "nocheck-small-blue",
                    on: {
                      click: function($event) {
                        _vm.options.delWatermark = !_vm.options.delWatermark
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticStyle: { float: "left" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "language.paySystem.freePlanPopup.itemTitle_watermark"
                        )
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "icon-util vip",
                    staticStyle: { float: "left", margin: "0 5px" }
                  })
                ])
              ]),
              _vm._v(" "),
              _vm.isExists
                ? _c("div", { staticClass: "email-paste-options" }, [
                    _c("div", { staticClass: "email-paste-option-title" }, [
                      _vm._v(
                        _vm._s(_vm.$t("language.emailTransfer.optionTitle"))
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "email-paste-option" }, [
                      _c("div", {
                        staticClass: "icon-util",
                        class:
                          _vm.options.isDoExists == 4 ? "check-radio" : "radio",
                        on: {
                          click: function($event) {
                            _vm.options.isDoExists = 4
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(
                          _vm._s(_vm.$t("language.emailTransfer.filterOption1"))
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "email-paste-option" }, [
                      _c("div", {
                        staticClass: "icon-util",
                        class:
                          _vm.options.isDoExists == 2 ? "check-radio" : "radio",
                        on: {
                          click: function($event) {
                            _vm.options.isDoExists = 2
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(
                          _vm._s(_vm.$t("language.emailTransfer.filterOption2"))
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "email-paste-option" }, [
                      _c("div", {
                        staticClass: "icon-util",
                        class:
                          _vm.options.isDoExists == 0 ? "check-radio" : "radio",
                        on: {
                          click: function($event) {
                            _vm.options.isDoExists = 0
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(
                          _vm._s(_vm.$t("language.emailTransfer.filterOption3"))
                        )
                      ])
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "popup-footer" }, [
                !_vm.loading
                  ? _c(
                      "button",
                      {
                        on: {
                          click: function($event) {
                            return _vm.paste()
                          }
                        }
                      },
                      [
                        _c("span", [
                          _vm._v(_vm._s(_vm.$t("language.common.ok")))
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.loading
                  ? _c("button", [
                      _c("span", {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.loading,
                            expression: "loading"
                          }
                        ]
                      })
                    ])
                  : _vm._e()
              ])
            ])
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-755e24df", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-755e24df","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/email_exploer_popups/paste_options_popup.vue
// module id = null
// module chunks = 